import * as $ from 'jquery';
import 'bootstrap';
import 'datepicker';
import 'selectize';
import * as moment from 'moment';
import { bookingFormSubmit } from "./c005-bookingform-submission";
import { headerContent } from "./c002";
import { bookingFormCommon } from "./c005-bookingform-common";

export class enrichHotel {
	$scope: any = $('#enrich-hotels-container');
	$scopeMob: any = $('#mob-enrich-hotels-container');
	$instance: any = $(".enrich-revamp");
	$error: any = [];
	private bookingFormSubmit = new bookingFormSubmit();
	private bcommon = new bookingFormCommon();
	nav(): void {
		let _self = this;
		let $checkIn: any = $('#check-in--container');
		let $viewBooking: any = $('#view-booking--container');
		let $flightStatus: any = $('#flight-status--container');
		let $login: any = $('#login-container');
		let $loggedin: any = $('#logged-in-user-menu');
		let $checkInMob: any = $('#mob-checkin--container');
		let $viewBookingMob: any = $('#mob-viewbooking--container');
		let $flightStatusMob: any = $('#mob-flightstatus--container');
		let $loginMob: any = $('#mob-login--container');
		let $loggedinMob: any = $('#mob-logged-in-user-menu');
		let $mhStay: any = $('#ibe-stay--container');
		let $mhUpgrade: any = $('#mhupgrade-in--container');
		let $mholidays: any = $('#mholiday-ibe--container');
		let $bookingWidget: any = $('#book-flight--container');
		let $moreLinks: any = $('#more-links--container');
		let $moreLinksMob: any = $('#mob-more-links--container');
		let $flightupgradeMob: any = $('#mob-flightupgrade--container');
		let $flightUpgrade: any = $('#view-upgrade');
		let $ibeNav: any = $('#bookingNav');
		let $ibeNavList: any = $('#bookingNav li');
		let $mobIbeNav: any = $('#mab-bookingnav.mobile #bookingNav');
		let $enrichPointTabs: any = $('#enrich-point-list');
		$flightUpgrade.hide();
		let $errorValidationGen: any = $('.error-validation');
		let $bookingFormTitle: any = $('.booking-form--title');
		let $dateFormTitle: any = $('.date-form--title');
		let $bookdateSelectorGen: any = $('.book-date--selector');
		let $couponCodeGen: any = $('.couponCode');
		let $redemptionLogin: any = $('.redemption-login .form-group');

		let $bookFlightMob: any = $('#mobile-bookflight--container');
		let $mhStayMob: any = $('#mob-stay--container');
		let $mhUpgradeMob: any = $('#mob-mhupgrade--container');
		let $mobMholidays: any = $('#mobile-mholidays--container');


		const topNavIbe = $('.desktop#mab-bookingnav [data-ibe--book-flight]');

		  $ibeNav.find('.redeem-flight').on('click', () => {
			_self.$scope.hide()
		  });
		// IBE Navigation show/hide detailed container
		$ibeNav.find('.enrich-hotels').on('click', () => {
			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.enrich-hotels').parent().addClass('selected');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header #mab-bookingnav .navbar-default').removeClass('mholidays-navbar');
			}
			// desktop stuff
			_self.$scope.show();
			$checkIn.hide();
			$viewBooking.hide();
			$flightStatus.hide();
			$login.hide();
			$mholidays.hide();
			$flightUpgrade.hide();
			$loggedin.addClass('hidden');
			$bookingWidget.hide();
			$moreLinks.hide();

			// mobile stuff
			_self.$scopeMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$flightupgradeMob.hide();
			$moreLinksMob.hide();
			// form stuff
			$errorValidationGen.hide();

			if (_self.$scope.find('.earn-points').parent().hasClass('selected')) {
				_self.$scope.find('#enrich-earn-points--container').show();
			}
			_self.clearFields();

		});
		$('#enrich-hotels-container .close-bookingroomhotel2').on('click', () => {
			$('[data-booking-passenger-details]').show();
		});
		let $passengerDetails: any = $('[data-booking-passenger-details]');
		let $passengerDetailsActive: any = $('[data-booking-passenger-details-selected]');

		// hide all passenger fields on load
		$passengerDetailsActive.hide();
		$passengerDetails.addClass('passenger-focused');
		$passengerDetails.show();
		$passengerDetails.find('.total-passengers').show();

	}
	// enrichpoints tabs hide/show start
	init(): void {
		let _self = this;
		$('.earn-points').delay(3000).trigger('click');
		let earnPointsTab = _self.$scope.find('.earn-points');
		let redeemPointsTab = _self.$scope.find('.redeem-points');


		earnPointsTab.click(function () {
			_self.clearFields();
			_self.$scope.find('#enrich-earn-points--container').show();
			_self.$scope.find('#enrich-redeem-points--container').hide();
			_self.$scope.css('padding-bottom', '20px');
			_self.$scope.find('#enrich-point-list li').removeClass('selected');
			_self.$scope.find('.earn-points').parent().addClass('selected');
			_self.$scope.find('.enrich-validation').hide();
			let $errorEls = _self.$scope.find('.has-error');
			
			$errorEls.each(function () {
				$(this).removeClass('has-error');
			});
		});
		redeemPointsTab.click(function () {
			_self.clearFields();
			_self.$scope.find('#enrich-earn-points--container').hide();
			_self.$scope.find('#enrich-redeem-points--container').show();
			_self.$scope.css('padding-bottom', '20px');
			_self.$scope.find('#enrich-point-list li').removeClass('selected');
			_self.$scope.find('.redeem-points').parent().addClass('selected');
			_self.$scope.find('.enrich-validation').hide();
			let $errorEls = _self.$scope.find('.has-error');
			$errorEls.each(function () {
				$(this).removeClass('has-error');
			});
		});

	}
	clearFields(): void{
		$('.enrichHotelEarnInputtoVal').val('');
		$('#enrich-hotels-container .booking-form--title').removeClass('input-filled');
		$('#enrich-hotels-container .date-form--title').removeClass('input-filled');
		$('.enrichHotelEarnInputtoVal').removeClass('input-focused');
		$('.enrichHotelEarnInputClass').val('');
		$('.enrichHotelEarnInputClass').removeClass('input-focused');
		$('.departureDate').val('');
		$('.departureDate').removeClass('input-focused');
		$('.returnDate').val('');
		$('.returnDate').removeClass('input-focused');
		$('.enrichHotelRedeemInputtoVal').val('');
		$('.enrichHotelRedeemInputtoVal').removeClass('input-focused');
		$('.enrichHotelRedeemInputClass').val('');
		$('.enrichHotelRedeemInputClass').removeClass('input-focused');
		$('.ticket-room--input').val(1);
		$('.ticket-adult--input').val(1);
		$('.ticket-child--input').val(0);
        $('.total-nos-rooms').html('1');
		$('.total-nos').html('1');

	}
	// enrichpoints tabs hide/show start
	initCalendar(): void {
		let _self = this;
		let nowDate: any = new Date();
		let today: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);
		let $ibeMHHMindays: any = $('[data-mhh-min-days]').length > 0 ? parseInt($('[data-mhh-min-days]').attr('data-mhh-min-days')) : 0;
		let tomorrow: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + $ibeMHHMindays, 0, 0, 0, 0);
		// let depRange: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + 184, 0, 0, 0, 0);
		let depRange = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#enrich-hotels-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
		let retRange: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + 0, 0, 0, 0, 0);
		let maxLimitDate: any = new Date(nowDate.getFullYear() + 1, nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);

		let $curDatepickerInst:any;
		let $curDatepickerTitle:string;

		function highlightDays(date: any) {
			var startDate = new Date($("#searchFlightDepart").datepicker("getDate"));
			var endDate = new Date($("#searchFlightReturn").datepicker("getDate"));

			if ((startDate <= date) && (date <= endDate)) {
				return [true, 'highlight'];
			} else {
				return [true, ''];
			}
		}
		let $dateFormat: any = 'd M yy',
			$departDate = _self.$scope.find('.departureDate')

				.datepicker({
					showButtonPanel: true,
					minDate: tomorrow,
					closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
					dateFormat: 'd M yy',
					numberOfMonths: 2,
					maxDate: depRange,
					onClose: function (selectedDate: any) {
						let nextDay: any = new Date(selectedDate);
						let depDate: any;
						depRange = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#enrich-hotels-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
						$('#enrich-hotels-container .returnDate').datepicker("option", "minDate", ((selectedDate && selectedDate != '') ? nextDay : tomorrow));
						if(getDate($('#enrich-earn-points--container .departureDate')[0])){
							depDate = getDate($('#enrich-earn-points--container .departureDate')[0]);
							if (selectedDate == '') {
								$('.returnDate').datepicker('option', 'maxDate', depRange);
							} else {
								$('.returnDate').datepicker('option', 'maxDate', new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate() + 30, 0, 0, 0, 0));
							}
						}
						else if(getDate($('#enrich-redeem-points--container .departureDate')[0])){
							depDate = getDate($('#enrich-redeem-points--container .departureDate')[0]);
							if (selectedDate == '') {
								$('.returnDate').datepicker('option', 'maxDate', depRange);
							} else {
								$('.returnDate').datepicker('option', 'maxDate', new Date(depDate.getFullYear(), depDate.getMonth(), depDate.getDate() + 30, 0, 0, 0, 0));
							}
						}
						
				
					},
					beforeShow: function(ele:any, obj:any) {
						_self.$instance.find('#ui-datepicker-div').removeClass('multicityTrip');
						_self.bcommon.appendDatepickerTitle('Please select your return date', obj.dpDiv);
						$curDatepickerInst  = obj.dpDiv[0];
						$curDatepickerTitle = ele.dataset.datepickerTitle;
					},
					afterShow: function() {
						_self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
					}
				})
				.on('change', function () {
					//$returnDate.datepicker('option', 'minDate', getDate(this));
					$returnDate.datepicker('setDate', null);
					let $nextReturnDate: any = $('.returnDate');
					if ($nextReturnDate.val() === "") {
						window.setTimeout($.proxy(function () {
							$nextReturnDate.focus();
						}, this), 100);
					}
					if ($('.departureDate').val() != '') {
						$('.departureDate').removeClass('has-empty-error');
						$('.dep-title').removeClass('input-filled');
					}
					else{
						$('.dep-title').addClass('input-filled');
					}
				}),
			$returnDate = _self.$scope.find('.returnDate')
				.datepicker({
					showButtonPanel: true,
					minDate: tomorrow,
					closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
					dateFormat: 'd M yy',
					numberOfMonths: 2,
					maxDate: $departDate + 30,
					beforeShow: function(ele:any, obj:any) {
						_self.$instance.find('#ui-datepicker-div').removeClass('multicityTrip');
						_self.bcommon.appendDatepickerTitle('Please select your return date', obj.dpDiv);
						$curDatepickerInst  = obj.dpDiv[0];
						$curDatepickerTitle = ele.dataset.datepickerTitle;
					},
					afterShow: function() {
						_self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
					}
				})
				.on('change', function () {
					if ($('.returnDate').val() != '') {
						$('.returnDate').removeClass('has-empty-error');
						$('.ret-title').removeClass('input-filled');
					}
					else{
						$('.ret-title').addClass('input-filled');
					}
					$('.passenger-details-selected').show();
				});

		let getDate: any = ($element: any) => {
			let $getDate: any;
			try {
				$getDate = $.datepicker.parseDate($dateFormat, $element.value);
			} catch (error) {
				$getDate = null;
			}
			return $getDate;
		}
		let depRangeFlight: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#enrich-hotels-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
		let depRangeHotel: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + parseInt($('#enrich-hotels-container .departureDate').attr('data-datepicker-days')), 0, 0, 0, 0);
		$('#enrich-hotels-container .departureDate').datepicker('option', 'maxDate', depRangeHotel);
		$('#enrich-hotels-container .returnDate').datepicker('option', 'maxDate', depRangeHotel);
		$('#enrich-hotels-container .departureDate').datepicker('option', 'maxDate', depRangeFlight);
		$('#enrich-hotels-container .returnDate').datepicker('option', 'maxDate', depRangeFlight);
	}
	inputFormFocus(): void {
		$('.form-validate')
			.off('focus', 'input')
			.on('focus', 'input', function () {
				let $input: any = $(this);
				// trigger focus state
				$input.addClass('input-focused');
				$('.booking-form--title', $input.parent()).addClass('input-filled');
				$('.date-form--title', $input.parent()).addClass('input-filled');

				// clear errors on focus
				$input.parent().removeClass('has-error');
				$('.booking-form--title', $input.parent()).removeClass('has-error');
				$('.date-form--title', $input.parent()).removeClass('has-error');
			})
			.off('blur', 'input')
			.on('blur', 'input', function () {
				let $input: any = $(this);
				if ($input.val() == '') {
					// trigger empty state
					$input.removeClass('input-focused');
					$('.booking-form--title', $input.parent()).removeClass('input-filled');
					// $('.date-form--title', $input.parent()).removeClass('input-filled');
				}
				else {
					// trigger focused state
					$input.addClass('input-focused');
					$('.booking-form--title', $input.parent()).addClass('input-filled');
					$('.date-form--title', $input.parent()).addClass('input-filled');
				}
			})
			.off('click', '.booking-form--title')
			.on('click', '.booking-form--title', function () {
				let $label: any = $(this);
				$label.addClass('input-filled');
				$('input', $label.parent()).addClass('input-focused').focus();
			})

		// handle initial states on load
		$('.form-validate input').each(function () {
			let $input: any = $(this);
			if ($input.val() == '') {
				// trigger empty state
				$input.removeClass('input-focused');
				$('.booking-form--title', $input.parent()).removeClass('input-filled');
				$('.date-form--title', $input.parent()).removeClass('input-filled');
			}
			else {
				// trigger focused state
				$input.addClass('input-focused');
				$('.booking-form--title', $input.parent()).addClass('input-filled');
				$('.date-form--title', $input.parent()).addClass('input-filled');
			}
		});

		
	}

    delay(callback:any, ms:any) {
		let timer:any = 0;
		return function() {
		  var context = this, args = arguments;
		  clearTimeout(timer);
		  timer = setTimeout(function () {
			callback.apply(context, args);
		  }, ms || 0);
		};
	  }
	  
	populateTuiEnrichEarnLocationList($scope: any): void {
		let _self = this;
		let $hotelInputVal: any;
		$(".enrichHotelEarnInputClass").attr('autocomplete', 'off');
		// $scope.find('.enrich-hotel-earn-display-tui-container').on('mouseleave', function () {
		// 	$(this).hide();
		// 	$scope.find('.enrichHotelEarnInputClass').removeClass('hotel-input-boarder');
		// });
		$(document).mouseup(function (event: any) {
			if ($(event.target).closest('.enrich-hotel-earn-display-tui-container').length
				=== 0) {
				$scope.find('.enrich-hotel-earn-display-tui-container').hide();
				$scope.find('.enrichHotelEarnInputClass').removeClass('hotel-input-boarder');
				if ($scope.find('#enrichHotelEarnInputVal').val() === '') {
					$scope.find('.enrichHotelEarnInputClass').val('');
					$scope.find('.enrichHotelEarnInputClass').removeClass('input-focused');
					// $('.booking-form--title', $scope.find('.enrichHotelEarnInputClass').parent()).removeClass('input-filled');
				}
			}
		});
		// $(document).keydown(function (event: any) {
		// 	if ($(event.target).closest('.enrich-hotel-earn-display-tui-container').length
		// 		=== 0) {
		// 		$scope.find('.enrich-hotel-earn-display-tui-container').hide();
		// 		$scope.find('.enrichHotelEarnInputClass').addClass('hotel-input-boarder');
		// 		if ($scope.find('#enrichHotelEarnInputVal').val() === '') {
		
		// 			$scope.find('.enrichHotelEarnInputClass').addClass('input-focused');
		// 			$('.booking-form--title', $scope.find('.enrichHotelEarnInputClass').parent()).addClass('input-filled');
		// 		}
		// 	}
		// });
		$scope.find('.enrichHotelEarnInputClass').keyup(_self.delay(function (e:any) {
			let trimSearchVal:any='';
			let searchTimeout:any=null;
			$hotelInputVal = $scope.find('.enrichHotelEarnInputClass').val();
			trimSearchVal=$hotelInputVal.split(" ").join("-");
			$scope.find('.enrichHotelEarnInputClass').addClass('input-focused');
			$('.booking-form--title', $scope.find('.enrichHotelEarnInputClass').parent()).addClass('input-filled');

			if ($hotelInputVal.length > 2) {		
				$scope.find('.enrich-hotel-earn-display-tui-container').show();
				$scope.find('.enrichHotelEarnInputClass').addClass('hotel-input-boarder');
				let hotellisturl: string = '';
				if (window.location.hostname === 'localhost' && window.location.port == "5000"){
					// _self.bcommon.preloader();
					hotellisturl = '/dummy-data/enrichHotelLocationList.json';
				}
				else {
					hotellisturl = '/bin/services/new/enrichhotellistsearchresult?cityName=' + trimSearchVal;
				}

				$.ajax({
					type: 'GET',
					url: hotellisturl,
					success: function (json: any) {
						if (window.location.hostname !== 'localhost') {
							json = JSON.parse(json);
						}
						_self.earnLocationlList($scope, json);
					},
					error: function (error: any) {
						console.log("Error while getting member info", error);
					}
				});

			}
		  }, 500));
		// $scope.find('.enrichHotelEarnInputClass').on('keyup', function (e: any) {
		// 	let trimSearchVal:any='';
		// 	let searchTimeout:any=null;
		// 	$hotelInputVal = $scope.find('.enrichHotelEarnInputClass').val();
		// 	trimSearchVal=$hotelInputVal.split(" ").join("-");
		// 	$scope.find('.enrichHotelEarnInputClass').addClass('input-focused');
		// 	$('.booking-form--title', $scope.find('.enrichHotelEarnInputClass').parent()).addClass('input-filled');

		// 	if ($hotelInputVal.length > 2) {
		// 		clearTimeout(searchTimeout);
		// 	    searchTimeout = setTimeout(function() { 		
		// 		$scope.find('.enrich-hotel-earn-display-tui-container').show();
		// 		$scope.find('.enrichHotelEarnInputClass').addClass('hotel-input-boarder');
		// 		let hotellisturl: string = '';
		// 		if (window.location.hostname === 'localhost' && window.location.port == "5000"){
		// 			// _self.bcommon.preloader();
		// 			hotellisturl = '/dummy-data/enrichHotelLocationList.json';
		// 		}
		// 		else {
		// 			hotellisturl = '/bin/services/new/enrichhotellistsearchresult?cityName=' + trimSearchVal;
		// 		}

		// 		$.ajax({
		// 			type: 'GET',
		// 			url: hotellisturl,
		// 			success: function (json: any) {
		// 				if (window.location.hostname !== 'localhost') {
		// 					json = JSON.parse(json);
		// 				}
		// 				_self.earnLocationlList($scope, json);
		// 			},
		// 			error: function (error: any) {
		// 				console.log("Error while getting member info", error);
		// 			}
		// 		});
		// 	}, 500);

		// 	}
	
		// });

	}
	populateTuiEnrichRedeemLocationList($scope: any): void {
		let _self = this;
		let $hotelInputVal: any;
		$(".enrichHotelRedeemInputClass").attr('autocomplete', 'off');
		// $scope.find('.enrich-hotel-redeem-display-tui-container').on('mouseleave', function () {
		// 	$(this).hide();
		// 	$scope.find('.enrichHotelRedeemInputClass').removeClass('hotel-input-boarder');
		// });
		$(document).mouseup(function (event: any) {
			if ($(event.target).closest('.enrich-hotel-redeem-display-tui-container').length
				=== 0) {
				$scope.find('.enrich-hotel-redeem-display-tui-container').hide();
				$scope.find('.enrichHotelRedeemInputClass').removeClass('hotel-input-boarder');
				if ($scope.find('#enrichHotelRedeemInputVal').val() === '') {
					$scope.find('.enrichHotelRedeemInputClass').val('');
					$scope.find('.enrichHotelRedeemInputClass').removeClass('input-focused');
					// $('.booking-form--title', $scope.find('.enrichHotelRedeemInputClass').parent()).removeClass('input-filled');
				}
			}
		});
		$scope.find('.enrichHotelRedeemInputClass').keyup(_self.delay(function (e:any) {
			let searchTimeout:any="";
			let trimSearchVal:any=null;
			$hotelInputVal = $scope.find('.enrichHotelRedeemInputClass').val();
			trimSearchVal=$hotelInputVal.split(" ").join("-");
			$scope.find('.enrichHotelRedeemInputClass').addClass('input-focused');
			$('.booking-form--title', $scope.find('.enrichHotelRedeemInputClass').parent()).addClass('input-filled');
			if ($hotelInputVal.length > 2) {
					$scope.find('.enrich-hotel-redeem-display-tui-container').show();
					$scope.find('.enrichHotelRedeemInputClass').addClass('hotel-input-boarder');
					let hotellisturl: string = '';
					if (window.location.hostname === 'localhost' && window.location.port == "5000") {
						// _self.bcommon.preloader();
						
						hotellisturl = '/dummy-data/enrichHotelLocationList.json';
					}
					else {
						hotellisturl = '/bin/services/new/enrichhotellistsearchresult?cityName=' + trimSearchVal;
						// _self.bcommon.preloader();
					}
	
					$.ajax({
						type: 'GET',
						url: hotellisturl,
						success: function (json: any) {
							if (window.location.hostname !== 'localhost') {
								json = JSON.parse(json);
							}
							_self.redeemLocationlList($scope, json);
						},
						error: function (error: any) {
							console.log("Error while getting member info", error);
						}
					});		

			}
		},500));

	}
	earnLocationlList($scope: any, response: any): any {
		let _self = this;
		// _self.bcommon.preloaderClose();
		let $hotelList: any = '';
		
		if (response.code=='200'&& response.results.length) {
			$hotelList += "<div class='hotel-tui-inner'>";
			// Object.keys(response).forEach(function(k){
			var itemCity = response.results;
			if (itemCity.length) {
				$hotelList += "<div class=' hotel-title'><span>Location</span></div>";
				Object.keys(itemCity).forEach(function (n) {

					$hotelList += "<div class='hotel-list' data-hotel" + itemCity[n].id + "= 'HotelID' id=hotel-opt" + n + " data-cityId='" + itemCity[n].id + "'  data-value='" + itemCity[n].name + "|" + itemCity[n].latitude + "," + itemCity[n].longitude + "'>" + itemCity[n]['description'] + "</div>";

				});
			}
			// });
			$hotelList += "</div>";
			$scope.find('.enrich-hotel-earn-display-tui-container').html($hotelList).text();
			$scope.find('.hotel-list').on('click', (evt: any) => {
				var evtVal = $('#' + evt.currentTarget.id).html();
				$scope.find('.enrichHotelEarnInputClass').focus();
				var evtValTextArray = evtVal.split('\u003cem\u003e');
				let getcityID: any = $('#' + evt.currentTarget.id).data('cityid');
				$scope.find('.enrichHotelEarnInputClass').val(evtValTextArray[0]);
				$scope.find('#enrichHotelEarnInputVal').val(evtValTextArray);
				$scope.find('#enrichHotelEarnInputtoVal').val(getcityID);
				// if($scope.selector == "#transferdrop"){
				// 	$scope.find('#geo-coords').val($('#'+evt.currentTarget.id).data('value').split('|')[1]);
				// }
				// if($scope.selector == "#transferpickup")
				// {
				// 	$scope.find('#geo-coords').val($('#'+evt.currentTarget.id).data('value').split('|')[1]);
				// }
				$scope.find('.enrich-hotel-earn-display-tui-container').hide();
				$scope.find('.enrichHotelEarnInputClass').removeClass('hotel-input-boarder');

				let $deptDateContainer = $scope.find('.dep-date');
				let $rtnDateContainer = $scope.find('.rtn-date');
				let $trvInfoContainer = $scope.find('.trv-info');

				$deptDateContainer.show();
				$rtnDateContainer.show();
				$trvInfoContainer.show();
				if ($scope.find('.enrichHotelEarnInputClass').val() !== '') {
					$scope.find('.departureDate').focus();
					$('.departuretransferDate').focus();
					$scope.find('.departureDateMobile').focus();
				}
			});
		} else {
			$hotelList = "<div class='hotel-not'>No result found! </div>";
			$scope.find('.enrich-hotel-earn-display-tui-container').html($hotelList);
		}
	}
	redeemLocationlList($scope: any, response: any): any {
		let $hotelList: any = '';
		if (response.code=='200'&& response.results.length) {
			$hotelList += "<div class='hotel-tui-inner'>";
			// Object.keys(response).forEach(function(k){
			var itemCity = response.results;
			if (itemCity.length) {
				$hotelList += "<div class=' hotel-title'><span>Location</span></div>";
				Object.keys(itemCity).forEach(function (n) {

					$hotelList += "<div class='hotel-list' data-hotel" + itemCity[n].id + "= 'HotelID' id=hotel-opt" + n + " data-cityId='" + itemCity[n].id + "'  data-value='" + itemCity[n].name + "|" + itemCity[n].latitude + "," + itemCity[n].longitude + "'>" + itemCity[n]['description'] + "</div>";

				});
			}
			// });
			$hotelList += "</div>";
			$scope.find('.enrich-hotel-redeem-display-tui-container').html($hotelList).text();
			$scope.find('.hotel-list').on('click', (evt: any) => {
				var evtVal = $('#' + evt.currentTarget.id).html();
				$scope.find('.enrichHotelRedeemInputClass').focus();
				var evtValTextArray = evtVal.split('\u003cem\u003e');
				let getcityID: any = $('#' + evt.currentTarget.id).data('cityid');
				$scope.find('.enrichHotelRedeemInputClass').val(evtValTextArray[0]);
				$scope.find('#enrichHotelRedeemInputVal').val(evtValTextArray);
				$scope.find('#enrichHotelRedeemInputtoVal').val(getcityID);
				// if($scope.selector == "#transferdrop"){
				// 	$scope.find('#geo-coords').val($('#'+evt.currentTarget.id).data('value').split('|')[1]);
				// }
				// if($scope.selector == "#transferpickup")
				// {
				// 	$scope.find('#geo-coords').val($('#'+evt.currentTarget.id).data('value').split('|')[1]);
				// }
				$scope.find('.enrich-hotel-redeem-display-tui-container').hide();
				$scope.find('.enrichHotelRedeemInputClass').removeClass('hotel-input-boarder');

				let $deptDateContainer = $scope.find('.dep-date');
				let $rtnDateContainer = $scope.find('.rtn-date');
				let $trvInfoContainer = $scope.find('.trv-info');

				$deptDateContainer.show();
				$rtnDateContainer.show();
				$trvInfoContainer.show();
				if ($scope.find('.enrichHotelRedeemInputClass').val() !== '') {
					$scope.find('.departureDate').focus();
					$('.departuretransferDate').focus();
					$scope.find('.departureDateMobile').focus();
				}
			});
		} else {
			$hotelList = "<div class='hotel-not'>No result found! </div>";
			$scope.find('.enrich-hotel-redeem-display-tui-container').html($hotelList);
		}
	}

	/**
	 * @function passengerType
	 * IBE Passenger type container
	 * !!! Properly scoped
	 */
	passengerType(): void {
		let _self = this;

		let $passengerDetails: any = _self.$instance.find('[data-booking-passenger-details]');
		let $passengerDetailsActive: any = _self.$instance.find('[data-booking-passenger-details-selected]');
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		$passengerDetails.on('click', () => {
			$(this).hide();
			$passengerDetailsActive.show();
			curInstance.find('.book-date--selector').removeClass('datepicker-selected');
		});

		$passengerDetailsActive.mouseleave((evt: any) => {
			if (evt.relatedTarget != null) {
				$(this).hide();
				$passengerDetailsActive.hide();
				$passengerDetails.addClass('passenger-focused');
				$passengerDetails.show();
				$passengerDetails.find('.total-passengers').show();
			}
		});

		$passengerDetailsActive.on('touchend', function (e: any) {
			if (!($(e.target).closest('.booking-person').length || $(e.target).is('.booking-person'))) {
				$passengerDetailsActive.hide();
				return false;
			} else {
				return true;
			}
		});
	}

	/**
	 * @function passengerDetailsEnrichHotelEarn
	 * Passenger details container
	 * !!! Properly scoped
	 */


	passengerDetailsEnrichHotelEarn(): void {
		let _self = this;

		let $ticketAdultInput: number = 1;
		let $ticketTeenagerInput: number = 0;
		let $ticketChildInput: number = 0;
		let $ticketInfantInput: number = 0;
		let $totalTickets: number = 1;
		let $totalPassenger: any = _self.$instance.find('#enrich-earn-points--container .total-passengers');
		let curInstance = _self.$instance.find('#enrich-earn-points--container'); // assign current instance to var as later requests will call latest assigned instance
		let $groupBooking = curInstance.find('.group-booking');
		let $isEnableNinePass: any = $('#enrich-earn-points--container #isEnableNinePass');
		let $ticketAdultInput_roomf: number = 1;
		let $ticketAdultInput_rooms: number = 1;
		let $ticketAdultInput_roomt: number = 1;
		let $ticketChildInput_roomf: number = 0;
		let $ticketChildInput_rooms: number = 0;
		let $ticketChildInput_roomt: number = 0;
		let $ticketInfantInput_roomf: number = 0;
		let $ticketInfantInput_rooms: number = 0;
		let $ticketInfantInput_roomt: number = 0;

		if (($isEnableNinePass.val() != 'null') && ($isEnableNinePass.val() != '0') && ($isEnableNinePass.val() != '')) {
			$groupBooking.show();
		} else {
			$groupBooking.hide();
		}


		// let $ticketYouthInput:number  = 0;

		$totalPassenger.find('#enrich-earn-points--container .total-nos').html($totalTickets);

		$('#enrich-earn-points--container .close-bookingroomhotel2').on('click', () => {
			if ($('#roomthre_earnenrichhoteldetails').hasClass('hide')) {
				$('#enrich-earn-points--container #roomtwo_earnenrichhoteldetails').addClass('hide');
				$('#enrich-earn-points--container  .ticket-adult--input2').val('0');
				$('#enrich-earn-points--container .ticket-infant--input2').val('0');
				$('#enrich-earn-points--container .ticket-child--input2').val('0');
				$('#roomtwo_earnenrichhoteldetails').find('.booking-ticket--nosr').remove();
				$('#enrich-earn-points--container .close-bookingroomhotel2').addClass('hide');
				updateHotelTicketQtys();
			}
			$('#enrich-earn-points--container .add_rooms_enrich_earn_hotel').show();
		});
		$('#enrich-earn-points--container .close-bookingroom_hotel3').on('click', () => {
			$('#roomthre_earnenrichhoteldetails').addClass('hide');
			$('#enrich-earn-points--container .add_rooms_enrich_earn_hotel').show();
			$('#enrich-earn-points--container .ticket-adult--input3').val('0');
			$('#enrich-earn-points--container .ticket-infant--input3').val('0');
			$('#enrich-earn-points--container .ticket-child--input3').val('0');
			$('#roomthre_earnenrichhoteldetails').find('.booking-ticket--nosr').remove();
			$('#enrich-earn-points--container .close-bookingroomhotel2').removeClass('hide');
			updateHotelTicketQtys();
		});

		$('#enrich-earn-points--container .add_rooms_enrich_earn_hotel').on('click', () => {
			if ($("#roomtwo_earnenrichhoteldetails").hasClass('hide') && $totalTickets < 5) {
				$('#roomtwo_earnenrichhoteldetails').removeClass('hide');
				$('#enrich-earn-points--container .ticket-adult--input2').val('1');
				$('#enrich-earn-points--container .close-bookingroomhotel2').removeClass('hide');
				curInstance.find('.booking-ticket--nos .age-label').show();
				updateHotelTicketQtys();
			}
			else if ($("#roomthre_earnenrichhoteldetails").hasClass('hide') && $totalTickets < 5) {

				$('#roomthre_earnenrichhoteldetails').removeClass('hide');
				curInstance.find('.booking-ticket--nos .age-label').show();
				$('#enrich-earn-points--container .close-bookingroomhotel2').addClass('hide');
				$('#enrich-earn-points--container .ticket-adult--input3').val('1');
				$('#enrich-earn-points--container .add_rooms_enrich_earn_hotel').hide();
				updateHotelTicketQtys();
			}
		});

		_self.$instance.find('#enrich-earn-points--container .ticket-nos-btn').on('click', function (e: any) {
			e.preventDefault();

			// get currently acted on input field
			var fieldName = $(this).attr('data-field'),
				type = $(this).attr('data-type'),
				input = curInstance.find("input[name='" + fieldName + "']"),
				currentVal = parseInt(input.val());

			// apply calculation to acted-on field (plus/minus)
			if (!isNaN(currentVal)) {
				input.data('oldValue', currentVal);
				if (type == 'minus') {
					if (currentVal > parseInt(input.attr('min'))) {
						input.val(currentVal - 1);
						input.trigger('change');
					}
					if (parseInt(input.val()) == parseInt(input.attr('min'))) {
						$(this).attr('disabled', true);
					}
				} else if (type == 'plus') {
					if (currentVal < input.attr('max')) {
						input.val(currentVal + 1);
						input.trigger('change');
					}
					if (parseInt(input.val()) == input.attr('max')) {
						$(this).attr('disabled', true);
					}
				}
			} else {
				input.val(0);
			}

			// updateHotelTicketQtys();
			if (!isNaN(currentVal) && fieldName == "passengersChildren" || fieldName == "passengersChildren2" || fieldName == "passengersChildren3") {
				// show age box if hide
				let room_var = fieldName;
				var currentChild = currentVal + 1;
				var currentChildmnus = currentVal - 1;
				//flight-container
				$('#enrich-earn-points--container .child-age-grp' + room_var).show();
				//$('.flight-container .child-age-grp').show();
				if (type == 'minus') {
					if (currentChildmnus % 8 == 0) {
						$("#enrich-earn-points--container #child-age-col" + room_var + currentChildmnus).remove();
						//$( ".flight-container #child-age-col"+currentChildmnus ).remove();
					} else {
						//Append box
						$('#enrich-earn-points--container #child-age-select' + room_var + currentVal).empty();
						//$('.flight-container #child-age-select'+currentVal).empty();
					}
				} else if (type == 'plus') {
					if (currentVal % 8 == 0) {
						// Append column
						let ageLabel = '';
						let errorChildAge = '';
						if (currentChild == 1) {
							ageLabel = 'Age';
							errorChildAge = '<div class="child-age-error" data-childage-limit="Child age must be between 2 and 12" data-childage="Child age is missing" style="display: none;">Please enter child age</div>';
						}
						var col1 = currentChild;
						var col2 = currentChild + 1;
						var col3 = currentChild + 2;
						var col4 = currentChild + 3;
						var col5 = currentChild + 4;
						var col6 = currentChild + 5;
						var col7 = currentChild + 6;
						var col8 = currentChild + 7;
						var col9 = currentChild + 9
						let $childAgeList = '<div class="col-lg-12 col-md-12 col-sm-12 booking-person" id="child-age-col' + room_var + currentVal + '">'
							+ '<div class="col-lg-12 col-md-12 col-sm-12 booking-ticket--nosr adult-nos"><div class="age-label">Age of Children</div>'
							+ errorChildAge
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col1 + '">'
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col2 + '"> '
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col3 + '">'
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col4 + '">'
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col5 + '"> '
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col6 + '">'
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col7 + '"> '
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col8 + '">'
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col9 + '">'
							+ '	</div>'
							+ '</div>'
							+ ' </div>'

						// $('.flight-container #child-age-grp').append($childAgeList);	
						// $('.flight-container #child-age-select'+currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput'+currentChild+'" name=""><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('#enrich-earn-points--container #child-age-grp' + room_var).append($childAgeList);
						$('#enrich-earn-points--container #child-age-select' + room_var + currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child ' + currentChild + '</label></div>'
							+ '<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput' + currentChild + '" name=""><option value="2" "selected">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');

					} else {
						//Append box
						// $('.flight-container #child-age-select'+currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput'+currentChild+'" name=""><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('#enrich-earn-points--container #child-age-select' + room_var + currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child ' + currentChild + '</label></div>'
							+ '<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput' + currentChild + '" name=""><option value="2" "selected">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');

					}
				}
				else {
					$('#enrich-earn-points--container #child-age-select' + room_var + currentChild).append('');
				}
			}
		});

		//Incude child age select box

		// disable user input on field (next statement will no longer have any effect)
		_self.$instance.find('#enrich-earn-points--container .minus-plus-input').attr('readonly', true);

		// store current value of input to data-attribute on focus
		// in case user manually edits fields
		_self.$instance.find('#enrich-earn-points--container .minus-plus-input').on('focusin', function () {
			$(this).data('oldValue', $(this).val());
		});

		// on value increment/decrement, update old value data-attribute
		_self.$instance.find('#enrich-earn-points--container .minus-plus-input').on('change', function () {
			let minValue = parseInt($(this).attr('min'));
			let maxValue = parseInt($(this).attr('max'));
			let valueCurrent = parseInt($(this).val());
			let name = $(this).attr('name');

			if (valueCurrent >= minValue) {
				curInstance.find(".ticket-nos-btn[data-type='minus'][data-field='" + name + "']").removeAttr('disabled');
			} else {
				$(this).data('oldValue', $(this).val());
			}

			if (valueCurrent <= maxValue) {
				curInstance.find(".ticket-nos-btn[data-type='plus'][data-field='" + name + "']").removeAttr('disabled');
			} else {
				$(this).data('oldValue', $(this).val());
			}
			updateHotelTicketQtys();
		});

		// prevent input to passenger number field by keyboard
		// only allow change from pressing buttons
		_self.$instance.find('#enrich-earn-points--container .minus-plus-input').on('keydown', function (e: any) {
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
				(e.keyCode == 65 && e.ctrlKey === true) ||
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				return;
			}
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});

		// run once on ready
		// _self.$instance.find('.minus-plus-input').trigger('change');
		updateHotelTicketQtys();

		/**
		 * calculate total ticket amount based on current values and populate display fields
		 * @return void
		 */
		function updateHotelTicketQtys() {
			let $passengerDetailsActive = curInstance.find('[data-booking-passenger-details-selected]');

			$ticketAdultInput_roomf = parseInt($('#enrich-earn-points--container .ticket-adult--input1').val());
			$ticketAdultInput_rooms = parseInt($('#enrich-earn-points--container .ticket-adult--input2').val());
			$ticketAdultInput_roomt = parseInt($('#enrich-earn-points--container .ticket-adult--input3').val());
			$ticketChildInput_roomf = parseInt($('#enrich-earn-points--container .ticket-child--input').val());
			$ticketChildInput_rooms = parseInt($('#enrich-earn-points--container .ticket-child--input2').val());
			$ticketChildInput_roomt = parseInt($('#enrich-earn-points--container .ticket-child--input3').val());

			// get current values in input field and assign to method vars
			$ticketAdultInput = $ticketAdultInput_roomf + $ticketAdultInput_rooms + $ticketAdultInput_roomt;
			$ticketChildInput = $ticketChildInput_roomf + $ticketChildInput_rooms + $ticketChildInput_roomt;


			// only adult, teenager and child tickets count towards limit
			$totalTickets = $ticketAdultInput + $ticketChildInput;
			// get current values in input field and assign to method vars
			// $ticketAdultInput = parseInt($passengerDetailsActive.find('.ticket-adult--input').val());
			// $ticketTeenagerInput = _self.isUkCitySelectedForIbeSearch ? parseInt($passengerDetailsActive.find('.ticket-teenager--input').val()) : 0;
			// $ticketChildInput = parseInt($passengerDetailsActive.find('.ticket-child--input').val());
			// //$ticketInfantInput = parseInt($passengerDetailsActive.find('.ticket-infant--input').val());

			// only adult, teenager and child tickets count towards limit
			// $totalTickets = $ticketAdultInput + (_self.isUkCitySelectedForIbeSearch ? $ticketTeenagerInput : 0) + $ticketChildInput;
			let $totalPassengersVal: any = $totalTickets;
			let $totalPassenger: any = curInstance.find('.total-passengers');

			// update hidden input value for total tickets added
			// update display text for total tickets added
			_self.$instance.find('#enrich-earn-points--container .total-tickets--value').val($totalTickets);
			$totalPassenger.find('.total-nos').html($totalPassengersVal);
			//let $totalPassengerDisplay:any 	  = curInstance.find('.flight-container .total-passengers');
			let $totalTravelerDisplay: any = curInstance.find('.total-passengers');
			if ($totalTickets >= 2) {
				//$totalPassengerDisplay.find('.type').html('Passengers');
				$totalTravelerDisplay.find('.type').html('Travellers');
			} else {
				//$totalPassengerDisplay.find('.type').html('Passenger');
				$totalTravelerDisplay.find('.type').html('Traveller');
			}



			// adult validations

			let $totalTickets_room1: number = $ticketAdultInput_roomf + $ticketChildInput_roomf;
			let $totalTickets_room2: number = $ticketAdultInput_rooms + $ticketChildInput_rooms;
			let $totalTickets_room3: number = $ticketAdultInput_roomt + $ticketChildInput_roomt;
			let $totalTickets_allrooms: number = 0;

			if ($totalTickets_room1 == 5 || $totalTickets >= 5) {
				$('#roomone_earnenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				$('#roomone_earnenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', true);
			}
			else {
				$('#roomone_earnenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				$('#roomone_earnenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', false);
			}
			if ($totalTickets_room2 == 4 || $totalTickets >= 5) {
				$('#roomtwo_earnenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				$('#roomtwo_earnenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', true);
			}

			else {
				$('#roomtwo_earnenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				$('#roomtwo_earnenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', false);
			}
			if ($totalTickets_room3 == 3 || $totalTickets >= 5) {
				$('#roomthre_earnenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				$('#roomthre_earnenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', true);
			}
			else {
				$('#roomthre_earnenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				$('#roomthre_earnenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', false);
			}

		}

	}

	/**
 * @function passengerDetailsEnrichHotelEarn
 * Passenger details container
 * !!! Properly scoped
 */


	passengerDetailsEnrichHotelRedeem(): void {
		let _self = this;

		let $ticketAdultInput: number = 1;
		let $ticketTeenagerInput: number = 0;
		let $ticketChildInput: number = 0;
		let $ticketInfantInput: number = 0;
		let $totalTickets: number = 1;
		let $totalPassenger: any = _self.$instance.find('#enrich-redeem-points--container .total-passengers');
		let curInstance = _self.$instance.find('#enrich-redeem-points--container'); // assign current instance to var as later requests will call latest assigned instance
		let $groupBooking = curInstance.find('.group-booking');
		let $isEnableNinePass: any = $('#enrich-redeem-points--container #isEnableNinePass');
		let $ticketAdultInput_roomf: number = 1;
		let $ticketAdultInput_rooms: number = 1;
		let $ticketAdultInput_roomt: number = 1;
		let $ticketChildInput_roomf: number = 0;
		let $ticketChildInput_rooms: number = 0;
		let $ticketChildInput_roomt: number = 0;
		let $ticketInfantInput_roomf: number = 0;
		let $ticketInfantInput_rooms: number = 0;
		let $ticketInfantInput_roomt: number = 0;

		if (($isEnableNinePass.val() != 'null') && ($isEnableNinePass.val() != '0') && ($isEnableNinePass.val() != '')) {
			$groupBooking.show();
		} else {
			$groupBooking.hide();
		}


		// let $ticketYouthInput:number  = 0;

		$totalPassenger.find('#enrich-redeem-points--container .total-nos').html($totalTickets);

		$('#enrich-redeem-points--container .close-bookingroomhotel2').on('click', () => {
			if ($('#roomthre_redeemenrichhoteldetails').hasClass('hide')) {
				$('#enrich-redeem-points--container #roomtwo_redeemenrichhoteldetails').addClass('hide');
				$('#enrich-redeem-points--container  .ticket-adult--input2').val('0');
				$('#enrich-redeem-points--container .ticket-infant--input2').val('0');
				$('#enrich-redeem-points--container .ticket-child--input2').val('0');
				$('#roomtwo_redeemenrichhoteldetails').find('.booking-ticket--nosr').remove();
				$('#enrich-redeem-points--container .close-bookingroomhotel2').addClass('hide');
				updateHotelTicketQtys();
			}
			$('#enrich-redeem-points--container .add_rooms_enrich_redeem_hotel').show();
		});
		$('#enrich-redeem-points--container .close-bookingroom_hotel3').on('click', () => {
			$('#roomthre_redeemenrichhoteldetails').addClass('hide');
			$('#enrich-redeem-points--container .add_rooms_enrich_redeem_hotel').show();
			$('#enrich-redeem-points--container .ticket-adult--input3').val('0');
			$('#enrich-redeem-points--container .ticket-infant--input3').val('0');
			$('#enrich-redeem-points--container .ticket-child--input3').val('0');
			$('#roomthre_redeemenrichhoteldetails').find('.booking-ticket--nosr').remove();
			$('#enrich-redeem-points--container .close-bookingroomhotel2').removeClass('hide');
			updateHotelTicketQtys();
		});

		$('#enrich-redeem-points--container .add_rooms_enrich_redeem_hotel').on('click', () => {
			if ($("#roomtwo_redeemenrichhoteldetails").hasClass('hide') && $totalTickets < 5) {
				$('#roomtwo_redeemenrichhoteldetails').removeClass('hide');
				$('#enrich-redeem-points--container .ticket-adult--input2').val('1');
				$('#enrich-redeem-points--container .close-bookingroomhotel2').removeClass('hide');
				curInstance.find('.booking-ticket--nos .age-label').show();
				updateHotelTicketQtys();
			}
			else if ($("#roomthre_redeemenrichhoteldetails").hasClass('hide') && $totalTickets < 5) {

				$('#roomthre_redeemenrichhoteldetails').removeClass('hide');
				curInstance.find('.booking-ticket--nos .age-label').show();
				$('#enrich-redeem-points--container .close-bookingroomhotel2').addClass('hide');
				$('#enrich-redeem-points--container .ticket-adult--input3').val('1');
				$('#enrich-redeem-points--container add_rooms_enrich_redeem_hotel').hide();
				updateHotelTicketQtys();
			}
		});

		_self.$instance.find('#enrich-redeem-points--container .ticket-nos-btn').on('click', function (e: any) {
			e.preventDefault();

			// get currently acted on input field
			var fieldName = $(this).attr('data-field'),
				type = $(this).attr('data-type'),
				input = curInstance.find("input[name='" + fieldName + "']"),
				currentVal = parseInt(input.val());

			// apply calculation to acted-on field (plus/minus)
			if (!isNaN(currentVal)) {
				input.data('oldValue', currentVal);
				if (type == 'minus') {
					if (currentVal > parseInt(input.attr('min'))) {
						input.val(currentVal - 1);
						input.trigger('change');
					}
					if (parseInt(input.val()) == parseInt(input.attr('min'))) {
						$(this).attr('disabled', true);
					}
				} else if (type == 'plus') {
					if (currentVal < input.attr('max')) {
						input.val(currentVal + 1);
						input.trigger('change');
					}
					if (parseInt(input.val()) == input.attr('max')) {
						$(this).attr('disabled', true);
					}
				}
			} else {
				input.val(0);
			}

			// updateHotelTicketQtys();
			if (!isNaN(currentVal) && fieldName == "passengersChildren" || fieldName == "passengersChildren2" || fieldName == "passengersChildren3") {
				// show age box if hide
				let room_var = fieldName;
				var currentChild = currentVal + 1;
				var currentChildmnus = currentVal - 1;
				//flight-container
				$('#enrich-redeem-points--container .child-age-grp' + room_var).show();
				//$('.flight-container .child-age-grp').show();
				if (type == 'minus') {
					if (currentChildmnus % 8 == 0) {
						$("#enrich-redeem-points--container #child-age-col" + room_var + currentChildmnus).remove();
						//$( ".flight-container #child-age-col"+currentChildmnus ).remove();
					} else {
						//Append box
						$('#enrich-redeem-points--container #child-age-select' + room_var + currentVal).empty();
						//$('.flight-container #child-age-select'+currentVal).empty();
					}
				} else if (type == 'plus') {
					if (currentVal % 8 == 0) {
						// Append column
						let ageLabel = '';
						let errorChildAge = '';
						if (currentChild == 1) {
							ageLabel = 'Age';
							errorChildAge = '<div class="child-age-error" data-childage-limit="Child age must be between 2 and 12" data-childage="Child age is missing" style="display: none;">Please enter child age</div>';
						}
						var col1 = currentChild;
						var col2 = currentChild + 1;
						var col3 = currentChild + 2;
						var col4 = currentChild + 3;
						var col5 = currentChild + 4;
						var col6 = currentChild + 5;
						var col7 = currentChild + 6;
						var col8 = currentChild + 7;
						var col9 = currentChild + 9
						let $childAgeList = '<div class="col-lg-12 col-md-12 col-sm-12 booking-person" id="child-age-col' + room_var + currentVal + '">'
							+ '<div class="col-lg-12 col-md-12 col-sm-12 booking-ticket--nosr adult-nos"><div class="age-label">Age of Children</div>'
							+ errorChildAge
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col1 + '">'
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col2 + '"> '
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col3 + '">'
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col4 + '">'
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col5 + '"> '
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col6 + '">'
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col7 + '"> '
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col8 + '">'
							+ '	</div>'
							+ '	<div class="row child-age-select" id="child-age-select' + room_var + col9 + '">'
							+ '	</div>'
							+ '</div>'
							+ ' </div>'

						// $('.flight-container #child-age-grp').append($childAgeList);	
						// $('.flight-container #child-age-select'+currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput'+currentChild+'" name=""><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('#enrich-redeem-points--container #child-age-grp' + room_var).append($childAgeList);
						$('#enrich-redeem-points--container #child-age-select' + room_var + currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child ' + currentChild + '</label></div>'
							+ '<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput' + currentChild + '" name=""><option value="2" "selected">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');

					} else {
						//Append box
						// $('.flight-container #child-age-select'+currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child '+currentChild+'</label></div>'
						// +'<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput'+currentChild+'" name=""><option value="0" selected>0 year</option><option value="1" selected>1 year</option><option value="2">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');
						$('#enrich-redeem-points--container #child-age-select' + room_var + currentChild).append('<div class="col-lg-6 col-md-6 col-sm-6"><label class="booking-form--title1" for="childCount"> Child ' + currentChild + '</label></div>'
							+ '<div class="col-lg-6 col-md-6 col-sm-6 childAgeInputSelect"><select id="childAgeInput' + currentChild + '" name=""><option value="2" "selected">2 years</option><option value="3">3 years</option><option value="4">4 years</option><option value="5">5 years</option><option value="6">6 years</option><option value="7">7 years</option><option value="8">8 years</option><option value="9">9 years</option><option value="10">10 years</option><option value="11">11 years</option><option value="12">12 years</option><option value="13">13 years</option><option value="14">14 years</option><option value="15">15 years</option><option value="16">16 years</option><option value="17">17 years</option></select></div>');

					}
				}
				else {
					$('#enrich-redeem-points--container #child-age-select' + room_var + currentChild).append('');
				}
			}
		});

		//Incude child age select box

		// disable user input on field (next statement will no longer have any effect)
		_self.$instance.find('#enrich-redeem-points--container .minus-plus-input').attr('readonly', true);

		// store current value of input to data-attribute on focus
		// in case user manually edits fields
		_self.$instance.find('#enrich-redeem-points--container .minus-plus-input').on('focusin', function () {
			$(this).data('oldValue', $(this).val());
		});

		// on value increment/decrement, update old value data-attribute
		_self.$instance.find('#enrich-redeem-points--container .minus-plus-input').on('change', function () {
			let minValue = parseInt($(this).attr('min'));
			let maxValue = parseInt($(this).attr('max'));
			let valueCurrent = parseInt($(this).val());
			let name = $(this).attr('name');

			if (valueCurrent >= minValue) {
				curInstance.find(".ticket-nos-btn[data-type='minus'][data-field='" + name + "']").removeAttr('disabled');
			} else {
				$(this).data('oldValue', $(this).val());
			}

			if (valueCurrent <= maxValue) {
				curInstance.find(".ticket-nos-btn[data-type='plus'][data-field='" + name + "']").removeAttr('disabled');
			} else {
				$(this).data('oldValue', $(this).val());
			}
			updateHotelTicketQtys();
		});

		// prevent input to passenger number field by keyboard
		// only allow change from pressing buttons
		_self.$instance.find('#enrich-redeem-points--container .minus-plus-input').on('keydown', function (e: any) {
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
				(e.keyCode == 65 && e.ctrlKey === true) ||
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				return;
			}
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});

		// run once on ready
		// _self.$instance.find('.minus-plus-input').trigger('change');
		updateHotelTicketQtys();

		/**
		 * calculate total ticket amount based on current values and populate display fields
		 * @return void
		 */
		function updateHotelTicketQtys() {
			let $passengerDetailsActive = curInstance.find('[data-booking-passenger-details-selected]');

			$ticketAdultInput_roomf = parseInt($('#enrich-redeem-points--container .ticket-adult--input1').val());
			$ticketAdultInput_rooms = parseInt($('#enrich-redeem-points--container .ticket-adult--input2').val());
			$ticketAdultInput_roomt = parseInt($('#enrich-redeem-points--container .ticket-adult--input3').val());
			$ticketChildInput_roomf = parseInt($('#enrich-redeem-points--container .ticket-child--input').val());
			$ticketChildInput_rooms = parseInt($('#enrich-redeem-points--container .ticket-child--input2').val());
			$ticketChildInput_roomt = parseInt($('#enrich-redeem-points--container .ticket-child--input3').val());

			// get current values in input field and assign to method vars
			$ticketAdultInput = $ticketAdultInput_roomf + $ticketAdultInput_rooms + $ticketAdultInput_roomt;
			$ticketChildInput = $ticketChildInput_roomf + $ticketChildInput_rooms + $ticketChildInput_roomt;


			// only adult, teenager and child tickets count towards limit
			$totalTickets = $ticketAdultInput + $ticketChildInput;
			// get current values in input field and assign to method vars
			// $ticketAdultInput = parseInt($passengerDetailsActive.find('.ticket-adult--input').val());
			// $ticketTeenagerInput = _self.isUkCitySelectedForIbeSearch ? parseInt($passengerDetailsActive.find('.ticket-teenager--input').val()) : 0;
			// $ticketChildInput = parseInt($passengerDetailsActive.find('.ticket-child--input').val());
			// //$ticketInfantInput = parseInt($passengerDetailsActive.find('.ticket-infant--input').val());

			// only adult, teenager and child tickets count towards limit
			// $totalTickets = $ticketAdultInput + (_self.isUkCitySelectedForIbeSearch ? $ticketTeenagerInput : 0) + $ticketChildInput;
			let $totalPassengersVal: any = $totalTickets;
			let $totalPassenger: any = curInstance.find('.total-passengers');

			// update hidden input value for total tickets added
			// update display text for total tickets added
			_self.$instance.find('#enrich-earn-points--container .total-tickets--value').val($totalTickets);
			$totalPassenger.find('.total-nos').html($totalPassengersVal);
			//let $totalPassengerDisplay:any 	  = curInstance.find('.flight-container .total-passengers');
			let $totalTravelerDisplay: any = curInstance.find('.total-passengers');
			if ($totalTickets >= 2) {
				//$totalPassengerDisplay.find('.type').html('Passengers');
				$totalTravelerDisplay.find('.type').html('Travellers');
			} else {
				//$totalPassengerDisplay.find('.type').html('Passenger');
				$totalTravelerDisplay.find('.type').html('Traveller');
			}



			// adult validations

			let $totalTickets_room1: number = $ticketAdultInput_roomf + $ticketChildInput_roomf;
			let $totalTickets_room2: number = $ticketAdultInput_rooms + $ticketChildInput_rooms;
			let $totalTickets_room3: number = $ticketAdultInput_roomt + $ticketChildInput_roomt;
			let $totalTickets_allrooms: number = 0;

			if ($totalTickets_room1 == 5 || $totalTickets >= 5) {
				$('#roomone_redeemenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				$('#roomone_redeemenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', true);
			}
			else {
				$('#roomone_redeemenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				$('#roomone_redeemenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', false);
			}
			if ($totalTickets_room2 == 4 || $totalTickets >= 5) {
				$('#roomtwo_redeemenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				$('#roomtwo_redeemenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', true);
			}

			else {
				$('#roomtwo_redeemenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				$('#roomtwo_redeemenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', false);
			}
			if ($totalTickets_room3 == 3 || $totalTickets >= 5) {
				$('#roomthre_redeemenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				$('#roomthre_redeemenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', true);
			}
			else {
				$('#roomthre_redeemenrichhoteldetails').find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				$('#roomthre_redeemenrichhoteldetails').find('.child-nos .input-group--btn .plus').attr('disabled', false);
			}

		}

	}
	/**
	 * @function ibeSingleFormSubmitHandler
	 * !!! Properly scoped
	 */
	enrichFormSubmitHandler(): void {
		let _self = this;

		let $errorValidation = _self.$instance.find('.enrich-validation').first();
		// let $singleTripSubmitBtn:any    = _self.$instance.find('.mholidays-single-city--bookflight');
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
		let $enrichHotelEarnSubmitBtn: any = _self.$instance.find('.enrich-earn-book-hotel');
		let $enrichHotelRdeemSubmitBtn: any = _self.$instance.find('.enrich-redeem-book-hotel');


		//if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )) {
		// _self.getOfficeCode();

		$enrichHotelEarnSubmitBtn.on('click', (evt: any) => {
			this.$error = [];
			evt.preventDefault();
			let ieversion = new headerContent();
			ieversion.checkIEVersion_disablePupup();
			$errorValidation.show();
			_self.bookingFormSubmit.enrichHotelEarnFormValidation(curInstance, function ($officeCode: any) {
				_self.bookingFormSubmit.enrichHotelEarnDeeplink(curInstance);

			});

		});
		$enrichHotelRdeemSubmitBtn.on('click', (evt: any) => {
			this.$error = [];
			evt.preventDefault();
			let ieversion = new headerContent();
			ieversion.checkIEVersion_disablePupup();
			$errorValidation.show();
			_self.bookingFormSubmit.enrichHotelRedeemFormValidation(curInstance, function ($officeCode: any) {
				_self.bookingFormSubmit.enrichHotelRedeemDeeplink(curInstance);

			});

		});

		//}
	}
	earnRoomPassengerDetails($scope: any): void {
		let _self = this;
		let $ticketRoomInput:number  = 1;
		let $ticketAdultInput:number  = 1;
		let $ticketChildInput:number  = 0;
		let $ticketInfantInput:number = 0;
		let $totalTickets:number      = 1;
		let $totalRooms:number      = 1;
		let $ticketTeenagerInput: number = 0;
		let $totalPassenger:any 	  = _self.$scope.find('#enrich-earn-points--container .total-passengers');
		let $totalRoom:any 	  = _self.$scope.find('#enrich-earn-points--container .total-rooms');
		let curInstance = _self.$instance.find('#enrich-earn-points--container'); // assign current instance to var as later requests will call latest assigned instance
		// let $groupBooking = curInstance.find('.group-booking');
		// let $isEnableNinePass: any	=	$('#isEnableNinePass');
 
		// $groupBooking.hide();

		// let $ticketYouthInput:number  = 0;

		_self.$scope.find('#enrich-earn-points--container .total-nos').html($totalTickets);
		_self.$scope.find('#enrich-earn-points--container .total-nos-rooms').html($totalRooms);

	

		_self.$instance.find('#enrich-earn-points--container .ticket-nos-btn').on('click', function(e:any) {
			e.preventDefault();

			// get currently acted on input field
			var fieldName  = $(this).attr('data-field'),
					type       = $(this).attr('data-type'),
					input      = curInstance.find("input[name='"+fieldName+"']"),
					currentVal = parseInt(input.val());

			// apply calculation to acted-on field (plus/minus)
			if (!isNaN(currentVal)) {
					input.data('oldValue', currentVal);
					if (type == 'minus') {
			
							if (currentVal > parseInt(input.attr('min'))) {
									input.val(currentVal - 1);
									input.trigger('change');
							}
							if (parseInt(input.val()) == parseInt(input.attr('min'))) {
									$(this).attr('disabled', true);
							}
							if(fieldName== "passengersRoom"){
								if(currentVal>$('#enrich-earn-points--container .passengersAdult').val())
								$('#enrich-earn-points--container .passengersAdult').val(currentVal - 1);
							}
							if(fieldName== "passengersAdult"){
								if(currentVal<=$('#enrich-earn-points--container .passengersRoom').val()){
									$('#enrich-earn-points--container .passengersRoom').val(currentVal - 1);
								}
							}
				
					} else if (type == 'plus') {
							if (currentVal < input.attr('max')) {
									input.val(currentVal + 1);
									input.trigger('change');
							}
							if (parseInt(input.val()) == input.attr('max')) {
									$(this).attr('disabled', true);
							}
							if(fieldName== "passengersRoom"){
								
								if(currentVal>= $('#enrich-earn-points--container .passengersAdult').val()){
									$('#enrich-earn-points--container .passengersAdult').val(currentVal + 1);
								}
							}
							if(fieldName== "passengersAdult"){
								if(currentVal<$('#enrich-earn-points--container .passengersRoom').val()){
									$('#enrich-earn-points--container .passengersRoom').val(currentVal + 1);
								}
							}
				
					}
			} else {
					input.val(0);
			}
		
			updateTicketQtys();
		});

		// disable user input on field (next statement will no longer have any effect)
		_self.$instance.find('#enrich-earn-points--container .minus-plus-input').attr('readonly', true);

		// store current value of input to data-attribute on focus
		// in case user manually edits fields
		_self.$instance.find('#enrich-earn-points--container .minus-plus-input').on('focusin', function() {
			 $(this).data('oldValue', $(this).val());
		});
		// cabin class on change
		$('.cabin-class').on('change', function() {
			if($('.ibe_freesidetrip').is(":visible")) 
					{
					$('.ibe_freesidetrip').hide();					
					$('.single-city--bookflight').show();
					}		
		});
		// on value increment/decrement, update old value data-attribute
		_self.$instance.find('#enrich-earn-points--container .minus-plus-input').on('change', function() {
			// adultInfantValidation();

			let minValue     = parseInt($(this).attr('min'));
			let maxValue     = parseInt($(this).attr('max'));
			let valueCurrent = parseInt($(this).val());
			let name         = $(this).attr('name');

			if (valueCurrent >= minValue) {
				curInstance.find(".ticket-nos-btn[data-type='minus'][data-field='"+name+"']").removeAttr('disabled');
			} else {
				$(this).data('oldValue',$(this).val());
			}

			if (valueCurrent <= maxValue) {
				curInstance.find(".ticket-nos-btn[data-type='plus'][data-field='"+name+"']").removeAttr('disabled');
			} else {
				$(this).data('oldValue',$(this).val());
			}
			updateTicketQtys();
		});

		// prevent input to passenger number field by keyboard
		// only allow change from pressing buttons
		_self.$instance.find('#enrich-earn-points--container .minus-plus-input').on('keydown', function (e:any) {
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
				(e.keyCode == 65 && e.ctrlKey === true) ||
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				return;
			}
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});

		// run once on ready
		// _self.$instance.find('.minus-plus-input').trigger('change');
		// updateTicketQtys();

		/**
		 * calculate total ticket amount based on current values and populate display fields
		 * @return void
		 */
		function updateTicketQtys() {
			let $passengerDetailsActive = curInstance.find('[data-booking-passenger-details-selected]');

			// get current values in input field and assign to method vars
			$ticketRoomInput = parseInt($passengerDetailsActive.find('.ticket-room--input').val());
			$ticketAdultInput = parseInt($passengerDetailsActive.find('.ticket-adult--input').val());
			$ticketChildInput = parseInt($passengerDetailsActive.find('.ticket-child--input').val());


			// only adult and child tickets count towards limit 
			$totalTickets = $ticketAdultInput + $ticketChildInput;
			$totalRooms =$ticketRoomInput;
			let $totalPassengersVal: any = $totalTickets 
			let $totalRoomsVal: any = $totalRooms 
			let $totalPassenger: any = curInstance.find('.total-passengers');
		

			// update hidden input value for total tickets added
			// update display text for total tickets added
			_self.$instance.find('#enrich-earn-points--container .total-tickets--value').val($totalTickets);
			$totalPassenger.find('.total-nos').html($totalPassengersVal);
			$totalPassenger.find('.total-nos-rooms').html($totalRoomsVal);
			let $totalTravelerDisplay: any = curInstance.find('.total-passengers');
			if ($totalTickets >= 2) {
				//$totalPassengerDisplay.find('.type').html('Passengers');
				$totalTravelerDisplay.find('.type').html('Guests');
			} else {
				//$totalPassengerDisplay.find('.type').html('Passenger');
				$totalTravelerDisplay.find('.type').html('Guest');
			}

			if ($totalRooms >= 2) {
				//$totalPassengerDisplay.find('.type').html('Passengers');
				$totalTravelerDisplay.find('.typeRoom').html('Rooms');
			} else {
				//$totalPassengerDisplay.find('.type').html('Passenger');
				$totalTravelerDisplay.find('.typeRoom').html('Room');
			}


			if ($totalTickets >= 5) {
				curInstance.find('.room-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', true);
			} else {
				curInstance.find('.room-nos .input-group--btn .plus').attr('disabled', false);
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', false);
			}
			if($ticketRoomInput>=3){
				curInstance.find('.room-nos .input-group--btn .plus').attr('disabled', true);
			}
		

		}

	}
	redeemRoomPassengerDetails($scope: any): void {
		let _self = this;
		let $ticketRoomInput:number  = 1;
		let $ticketAdultInput:number  = 1;
		let $ticketChildInput:number  = 0;
		let $ticketInfantInput:number = 0;
		let $totalTickets:number      = 1;
		let $totalRooms:number      = 1;
		let $ticketTeenagerInput: number = 0;
		let $totalPassenger:any 	  = _self.$scope.find('#enrich-redeem-points--container .total-passengers');
		let $totalRoom:any 	  = _self.$scope.find('#enrich-redeem-points--container .total-rooms');
		let curInstance = _self.$instance.find('#enrich-redeem-points--container'); // assign current instance to var as later requests will call latest assigned instance
		// let $groupBooking = curInstance.find('.group-booking');
		// let $isEnableNinePass: any	=	$('#isEnableNinePass');
 
		// $groupBooking.hide();

		// let $ticketYouthInput:number  = 0;

		_self.$scope.find('#enrich-redeem-points--container .total-nos').html($totalTickets);
		_self.$scope.find('#enrich-redeem-points--container .total-nos-rooms').html($totalRooms);

	

		_self.$instance.find('#enrich-redeem-points--container .ticket-nos-btn').on('click', function(e:any) {
			e.preventDefault();

			// get currently acted on input field
			var fieldName  = $(this).attr('data-field'),
					type       = $(this).attr('data-type'),
					input      = curInstance.find("input[name='"+fieldName+"']"),
					currentVal = parseInt(input.val());

			// apply calculation to acted-on field (plus/minus)
			if (!isNaN(currentVal)) {
					input.data('oldValue', currentVal);
					if (type == 'minus') {
			
							if (currentVal > parseInt(input.attr('min'))) {
									input.val(currentVal - 1);
									input.trigger('change');
							}
							if (parseInt(input.val()) == parseInt(input.attr('min'))) {
									$(this).attr('disabled', true);
							}
							if(fieldName== "passengersRoom"){
								if(currentVal>$('#enrich-redeem-points--container .passengersAdult').val())
								$('#enrich-redeem-points--container .passengersAdult').val(currentVal - 1);
							}
							if(fieldName== "passengersAdult"){
								if(currentVal<=$('#enrich-redeem-points--container .passengersRoom').val()){
									$('#enrich-redeem-points--container .passengersRoom').val(currentVal - 1);
								}
							}
				
					} else if (type == 'plus') {
							if (currentVal < input.attr('max')) {
									input.val(currentVal + 1);
									input.trigger('change');
							}
							if (parseInt(input.val()) == input.attr('max')) {
									$(this).attr('disabled', true);
							}
							if(fieldName== "passengersRoom"){
								
								if(currentVal>= $('#enrich-redeem-points--container .passengersAdult').val()){
									$('#enrich-redeem-points--container .passengersAdult').val(currentVal + 1);
								}
							}
							if(fieldName== "passengersAdult"){
								if(currentVal<$('#enrich-redeem-points--container .passengersRoom').val()){
									$('#enrich-redeem-points--container .passengersRoom').val(currentVal + 1);
								}
							}
				
					}
			} else {
					input.val(0);
			}
		
			updateTicketQtys();
		});

		// disable user input on field (next statement will no longer have any effect)
		_self.$instance.find('#enrich-redeem-points--container .minus-plus-input').attr('readonly', true);

		// store current value of input to data-attribute on focus
		// in case user manually edits fields
		_self.$instance.find('#enrich-redeem-points--container .minus-plus-input').on('focusin', function() {
			 $(this).data('oldValue', $(this).val());
		});
		// cabin class on change
		$('.cabin-class').on('change', function() {
			if($('.ibe_freesidetrip').is(":visible")) 
					{
					$('.ibe_freesidetrip').hide();					
					$('.single-city--bookflight').show();
					}		
		});
		// on value increment/decrement, update old value data-attribute
		_self.$instance.find('#enrich-redeem-points--container .minus-plus-input').on('change', function() {
			// adultInfantValidation();

			let minValue     = parseInt($(this).attr('min'));
			let maxValue     = parseInt($(this).attr('max'));
			let valueCurrent = parseInt($(this).val());
			let name         = $(this).attr('name');

			if (valueCurrent >= minValue) {
				curInstance.find(".ticket-nos-btn[data-type='minus'][data-field='"+name+"']").removeAttr('disabled');
			} else {
				$(this).data('oldValue',$(this).val());
			}

			if (valueCurrent <= maxValue) {
				curInstance.find(".ticket-nos-btn[data-type='plus'][data-field='"+name+"']").removeAttr('disabled');
			} else {
				$(this).data('oldValue',$(this).val());
			}
			updateTicketQtys();
		});

		// prevent input to passenger number field by keyboard
		// only allow change from pressing buttons
		_self.$instance.find('#enrich-earn-points--container .minus-plus-input').on('keydown', function (e:any) {
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
				(e.keyCode == 65 && e.ctrlKey === true) ||
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				return;
			}
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});

		// run once on ready
		// _self.$instance.find('.minus-plus-input').trigger('change');
		// updateTicketQtys();

		/**
		 * calculate total ticket amount based on current values and populate display fields
		 * @return void
		 */
		function updateTicketQtys() {
			let $passengerDetailsActive = curInstance.find('[data-booking-passenger-details-selected]');

			// get current values in input field and assign to method vars
			$ticketRoomInput = parseInt($passengerDetailsActive.find('.ticket-room--input').val());
			$ticketAdultInput = parseInt($passengerDetailsActive.find('.ticket-adult--input').val());
			$ticketChildInput = parseInt($passengerDetailsActive.find('.ticket-child--input').val());


			// only adult and child tickets count towards limit 
			$totalTickets = $ticketAdultInput + $ticketChildInput;
			$totalRooms =$ticketRoomInput;
			let $totalPassengersVal: any = $totalTickets 
			let $totalRoomsVal: any = $totalRooms 
			let $totalPassenger: any = curInstance.find('.total-passengers');
		

			// update hidden input value for total tickets added
			// update display text for total tickets added
			_self.$instance.find('#enrich-earn-points--container .total-tickets--value').val($totalTickets);
			$totalPassenger.find('.total-nos').html($totalPassengersVal);
			$totalPassenger.find('.total-nos-rooms').html($totalRoomsVal);
			let $totalTravelerDisplay: any = curInstance.find('.total-passengers');
			if ($totalTickets >= 2) {
				//$totalPassengerDisplay.find('.type').html('Passengers');
				$totalTravelerDisplay.find('.type').html('Guests');
			} else {
				//$totalPassengerDisplay.find('.type').html('Passenger');
				$totalTravelerDisplay.find('.type').html('Guest');
			}

			if ($totalRooms >= 2) {
				//$totalPassengerDisplay.find('.type').html('Passengers');
				$totalTravelerDisplay.find('.typeRoom').html('Rooms');
			} else {
				//$totalPassengerDisplay.find('.type').html('Passenger');
				$totalTravelerDisplay.find('.typeRoom').html('Room');
			}


			if ($totalTickets >= 5) {
				curInstance.find('.room-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', true);
			} else {
				curInstance.find('.room-nos .input-group--btn .plus').attr('disabled', false);
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', false);
			}
			if($ticketRoomInput>=3){
				curInstance.find('.room-nos .input-group--btn .plus').attr('disabled', true);
			}
		

		}

	}

}

let scope: Element = document.querySelector('#enrich-hotels-container');
if (scope) {
	try {

		let enrichHotels = new enrichHotel();
		enrichHotels.nav();
		enrichHotels.init();
		enrichHotels.initCalendar();
		enrichHotels.inputFormFocus();
		enrichHotels.populateTuiEnrichEarnLocationList($('#enrich-earn-points--container'));
		enrichHotels.populateTuiEnrichRedeemLocationList($('#enrich-redeem-points--container'));
		// enrichHotels.passengerDetailsEnrichHotelEarn();
		// enrichHotels.passengerDetailsEnrichHotelRedeem();
		enrichHotels.passengerType();
		enrichHotels.earnRoomPassengerDetails('#enrich-earn-points--container');
		enrichHotels.redeemRoomPassengerDetails('#enrich-redeem-points--container');

		enrichHotels.enrichFormSubmitHandler();
	} catch (e) { console.error(e); }
}

